import React from 'react';
import { Assessment } from '../types';

interface AssessmentDetailsProps {
  assessments: Assessment[];
}

export default function AssessmentDetails({ assessments }: AssessmentDetailsProps) {
  return (
    <div className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="space-y-12">
          {assessments.map((assessment) => (
            <div key={assessment.id} className="border-b border-gray-200 pb-8 last:border-b-0">
              <h3 className="text-2xl font-semibold text-brand-primary mb-4">{assessment.name}</h3>
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <p className="text-gray-600 mb-4">{assessment.description}</p>
                  <div className="bg-emerald-50 p-4 rounded-lg">
                    <h4 className="font-medium text-brand-primary mb-2">Key Benefits</h4>
                    <ul className="list-disc list-inside text-gray-600 space-y-2">
                      {assessment.features.map((feature, index) => (
                        <li key={index}>{feature}</li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h4 className="font-medium text-gray-900 mb-4">Assessment Details</h4>
                    <dl className="space-y-4">
                      <div>
                        <dt className="text-sm font-medium text-gray-500">Timeline</dt>
                        <dd className="text-gray-900">{assessment.estimatedTime}</dd>
                      </div>
                      <div>
                        <dt className="text-sm font-medium text-gray-500">Investment</dt>
                        <dd className="text-gray-900">Starting at ${assessment.price} USD</dd>
                      </div>
                      <div>
                        <dt className="text-sm font-medium text-gray-500">Deliverables</dt>
                        <dd className="text-gray-900">Comprehensive report with actionable recommendations</dd>
                      </div>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}